<template>
  <div>
    <div class="container-text-processos">
      <v-btn depressed @click="voltarParaPesquisa" class="btn-processo-interno-voltar">
        <v-icon>arrow_back</v-icon>
        Voltar para pesquisa
      </v-btn>
      <h2 class="text-titulo-processo-internos">Edital Nº {{ processo.numeroEdital }}</h2>
    </div>
    <div class="container-main-processo-interno">

      <div class="container-chip-top">
        <span class="chip-processo chip-num-processo">Nº {{ processo.numProcesso }}</span>
        <span class="chip-processo chip-data-abertura">{{
            processo.dataAbertura | az-date(humanizarFormatoDataPortalProcessoInterno(processo.dataAbertura))
          }}</span>
      </div>
      <v-layout wrap class="container-processo-info">
        <v-flex xs12 sm12 md8 d-flex>
          <div>
            <h2 class="processo-info-orgao">{{ processo.orgao.nome }}</h2>
            <h3 class="processo-info-municipio">{{ processo.orgao.municipio.descricao }} /
              {{ processo.orgao.municipio.uf }}</h3>
            <p class="processo-info-resumo-objeto">Resumo do Objeto</p>
            <p class="processo-info-objeto">{{ processo.objeto }}</p>
            <div class="processo-info-container-principal-data">
              <div class="processo-info-container-data">
                <img src="https://comprasbr.com.br/wp-content/themes/portal/assets-theme/img/calendario.svg" alt=""
                     class="processo-info-img" width="24">
                <div class="processo-info-container-data-texto">
                  <p class="processo-info-data-titulo">Início de Envio de Propostas</p>
                  <p class="processo-info-data-texto">{{
                      processo.dataIniEnvioProposta | az-date(humanizarFormatoDataPortal(processo.dataIniEnvioProposta))
                    }}</p>
                </div>
              </div>
              <div class="processo-info-container-data">
                <img src="https://comprasbr.com.br/wp-content/themes/portal/assets-theme/img/calendario.svg" alt=""
                     class="processo-info-img" width="24">
                <div class="processo-info-container-data-texto">
                  <p class="processo-info-data-titulo">Fim de Envio de Propostas</p>
                  <p class="processo-info-data-texto">{{
                      processo.dataFimEnvioProposta | az-date(humanizarFormatoDataPortal(processo.dataFimEnvioProposta))
                    }}</p>
                </div>
              </div>
              <div class="processo-info-container-data">
                <img src="https://comprasbr.com.br/wp-content/themes/portal/assets-theme/img/calendario.svg" alt=""
                     class="processo-info-img" width="24">
                <div class="processo-info-container-data-texto">
                  <p class="processo-info-data-titulo">Abertura da Licitação</p>
                  <p class="processo-info-data-texto">
                    {{ processo.dataAbertura | az-date(humanizarFormatoDataPortal(processo.dataAbertura)) }}</p>
                </div>
              </div>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 sm12 md4 d-flex>
          <div class="processo-info-container-cadastro">
            <h3 class="processo-info-cadastrar">Ainda não tem cadastro?</h3>
            <v-btn depressed @click="redirecionarCadastro" class="chip-processo chip-participar">
              Participe Agora!
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap class="container-processo-info">
        <v-flex xs12 sm12 md5 d-flex>

          <div class="processo-info-detalhe-container-principal">

            <div class="processo-info-detalhe-container">
              <div class="processo-info-detalhe">
                <img src="https://comprasbr.com.br/wp-content/themes/portal/assets-theme/img/licitacao/licitacao1.svg"
                     alt=""
                     class="processo-info-detalhe-img" width="48">
                <div class="processo-info-container-detalhe-texto">
                  <p class="processo-info-detalhe-titulo">Modalidade</p>
                  <p class="processo-info-detalhe-texto">{{ processo.modalidade | azEnum(modalidadesLicitacao) }}</p>
                </div>
              </div>
              <div class="processo-info-detalhe">
                <img src="https://comprasbr.com.br/wp-content/themes/portal/assets-theme/img/licitacao/licitacao2.svg"
                     alt=""
                     class="processo-info-detalhe-img" width="48">
                <div class="processo-info-container-detalhe-texto">
                  <p class="processo-info-detalhe-titulo">Tipo</p>
                  <p class="processo-info-detalhe-texto">{{ processo.tipoLicitacao | azEnum(tiposLicitacao) }}</p>
                </div>
              </div>
            </div>
            <div class="processo-info-detalhe-container">
              <div class="processo-info-detalhe">
                <img src="https://comprasbr.com.br/wp-content/themes/portal/assets-theme/img/licitacao/licitacao3.svg"
                     alt=""
                     class="processo-info-detalhe-img" width="48">
                <div class="processo-info-container-detalhe-texto">
                  <p class="processo-info-detalhe-titulo">Disputa</p>
                  <p class="processo-info-detalhe-texto">{{ processo.tipoDisputa | azEnum(tiposDisputa) }}</p>
                </div>
              </div>
              <div class="processo-info-detalhe">
                <img src="https://comprasbr.com.br/wp-content/themes/portal/assets-theme/img/licitacao/licitacao4.svg"
                     alt=""
                     class="processo-info-detalhe-img" width="48">
                <div class="processo-info-container-detalhe-texto">
                  <p class="processo-info-detalhe-titulo">Pregoeiro</p>
                  <p class="processo-info-detalhe-texto">{{ processo.pregoeiro }}</p>
                </div>
              </div>
            </div>
            <div class="processo-info-detalhe-container">
              <div class="processo-info-detalhe">
                <img src="https://comprasbr.com.br/wp-content/themes/portal/assets-theme/img/licitacao/licitacao1.svg"
                     alt=""
                     class="processo-info-detalhe-img" width="48">
                <div class="processo-info-container-detalhe-texto">
                  <p class="processo-info-detalhe-titulo">Modo de Disputa</p>
                  <p class="processo-info-detalhe-texto">{{ processo.modoDisputa | azEnum(modosDisputa) }}</p>
                </div>
              </div>
            </div>
          </div>

        </v-flex>
        <v-flex xs12 sm12 md7 d-flex>
          <div class="processo-info-container-anexos">
            <h4 class="processo-info-anexo-titulo">Documentos do Processo</h4>
            <div class="processo-info-anexo-vazio" v-if="processo.documentos.length == 0">
              <span>Não há documentos publicados!</span>
            </div>
            <div v-else class="processo-info-anexo-container" :key="documento.id"
                 v-for="documento in processo.documentos">
              <span class="chip-documento">
                <span class="processo-info-anexo-nome">&bull; {{ documento.arquivoNome }}</span>
                <span
                    class="processo-info-anexo-data">&bull; {{
                    documento.dataCadastro | az-date(humanizarFormatoDataPortal(documento.dataCadastro))
                  }}</span>
                <a v-if="documento.arquivoUri" :href="criarLinkDownload(documento.arquivoUri)" title="Download do Anexo"
                   target="_blank" class="processo-info-anexo-download">
                  <v-icon color="#fff">file_download</v-icon>
                </a>
              </span>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap class="container-processo-lotes">
        <v-flex xs12 sm12 md12 d-flex>
          <div class="processo-lotes-container">
            <h2 class="processo-lotes-titulo line-center">Andamento do Processo</h2>

            <pagina-interna-licitacao-lotes-tabela
                :itens="lotes"
                :paginas="paginas"
                :total-itens="totalItens"
                :paginacao="paginacao"
                @paginar="paginar"
            />
          </div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>

import {mapActions} from 'vuex'
import {actionTypes} from '@/core/constants'
import {tiposDisputa, modalidadesLicitacao, tiposLicitacao, modosDisputa} from '@/core/constants'
import PaginaInternaLicitacaoLotesTabela from '@/views/pages/commons/portal/licitacao/paginaInternaLicitacao/PaginaInternaLicitacaoLotesTabela.vue'

export default {
  name: 'PaginaInternaLicitacao',
  components: {PaginaInternaLicitacaoLotesTabela},
  data() {
    return {
      processoId: null,
      processo: {
        numeroEdital: null,
        numProcesso: null,
        dataAbertura: null,
        orgao: {nome: null, municipio: {descricao: null, uf: null}},
        documentos: [],
      },
      paginacao:{
        size: 10,
        page: 1,
      },
      lotes: [],
      paginas: 0,
      totalItens: 10,
      tiposDisputa,
      modalidadesLicitacao,
      tiposLicitacao,
      modosDisputa
    }
  },
  async mounted() {
    this.setProcessoId()
    await this.buscarProcesso()
    await this.buscarLotes()

  },
  methods: {
    ...mapActions([
      actionTypes.BUSCAR_PROCESSO_LICITACAO,
      actionTypes.BUSCAR_LOTES_PAGINA_INTERNA,
    ]),
    voltarParaPesquisa() {
      this.$router.push({name: 'licitacaoListagemProcessos'})
    },
    setProcessoId() {
      if (this.$route.params.id) {
        this.processoId = this.$route.params.id
      }
    },
    async buscarProcesso() {
      const resultado = await this.buscarProcessoLicitacao(this.processoId)
      if (resultado) {
        this.processo = resultado
      }
    },
    async buscarLotes(){
      const resultado = await this.buscarLotesPaginaInterna({ processoId: this.processoId,
        paginacao: this.paginacao});
      if(resultado){
        this.lotes = resultado.items
        this.paginas = resultado.totalPages
        this.totalItens = resultado.totalElements
      }
    },
    paginar(paginacao) {
      this.paginacao = paginacao
      this.buscarLotes()
    },
    redirecionarCadastro() {
      const url = new URL(window.location.href);
      console.log(url)
      if(url.hostname === 'comprasbr.com.br'){
        window.open('https://comprasbr.com.br/cadastro/');
      } else if(url.hostname === 'hom.portal.comprasbr.com.br'){
        window.open('http://hom.portal.comprasbr.com.br/cadastro/')
      } else {
        this.$router.push({name: 'licitacaoCadastroUsuario'})
      }
    },
    async atualizaDados(){
      this.desabilitarLoadingGlobal()
      await this.buscarProcesso()
      await this.buscarLotes()
      this.habilitarLoadingGlobal()
    }
  },
  timers: {
    atualizaDados: {
      time: 10000,
      repeat: true,
      autostart: true
    }
  }
}
</script>

<style scoped lang="stylus">

.text-titulo-processo-internos
  text-align center
  font-size 42px
  font-weight 600
  color #fff
  line-height 1

.btn-processo-interno-voltar
  background none !important
  font-weight 700
  color #fff

.btn-processo-interno-voltar:hover
  cursor pointer
  color #F4B310 !important

.container-main-processo-interno
  padding 40px

.container-chip-top
  display flex
  flex-direction row

.chip-processo
  padding 10px 25px
  border-radius 50px
  font-weight 400
  color #fff

.chip-num-processo
  background-color #58954D
  margin-right 10px

.chip-data-abertura
  background-color #F4B310

.container-processo-info
  padding-top 20px

.processo-info-orgao
  font-weight 600
  font-size 42px
  line-height 1

.processo-info-municipio
  font-weight 600
  font-size 18px

.processo-info-resumo-objeto
  font-weight 600
  font-size 14px
  margin 0px
  margin-top 10px

.processo-info-objeto
  font-size 14px

.processo-info-container-cadastro
  background-color #F9F9F9
  padding 5px
  border-radius 5px
  display flex
  flex-direction column
  align-items center
  justify-content center

.chip-participar
  background-color #F4B310 !important
  text-transform none

.chip-participar:hover
  cursor pointer

.processo-info-cadastrar
  font-weight 600
  font-size 18px
  text-align center

.processo-info-container-principal-data
  margin-top 30px
  display flex
  flex-direction row

.processo-info-container-data
  margin-right 30px
  display flex
  flex-direction row

.processo-info-img
  margin-top -20px

.processo-info-container-data-texto
  margin-left 5px

.processo-info-data-titulo
  font-weight 600
  font-size 14px
  margin 0px

.processo-info-data-texto
  font-size 14px

.processo-info-container-anexos
  background-color #1577AA
  padding 30px
  min-height 300px

.processo-info-anexo-titulo
  font-weight 600
  font-size 18px
  color #fff

.processo-info-anexo-vazio
  font-weight 600
  color #fff
  height 200px
  display flex
  flex-direction column
  justify-content center
  align-items center

.processo-info-anexo-container
  margin-top 20px
  display flex
  flex-direction row

.chip-documento
  padding 10px 25px
  border-radius 50px
  font-weight 400
  color #fff
  background-color #F4B310

.processo-info-anexo-download
  margin-left 10px

.processo-info-anexo-data
  margin-left 10px

.processo-info-anexo-nome
  max-width 20vw

.processo-info-detalhe-container
  display flex
  flex-direction row
  margin-bottom 20px

.processo-info-detalhe
  margin-right 30px
  display flex
  flex-direction row
  width 200px

.processo-info-detalhe-titulo
  font-weight 600
  font-size 14px
  margin-bottom 0px

.processo-info-detalhe-img
  margin-top -20px

.processo-info-container-detalhe-texto
  margin-left 10px

.container-processo-lotes
  margin-top 80px

.processo-lotes-titulo
  text-align center
  font-weight 600
  font-size 42px
  color #58954D

.line-center
  position relative
  padding-bottom 20px

.line-center:before
  width 100px
  position absolute
  background #F4B310
  height 5px

.line-center:before
  left 50%
  margin-left -50px
  bottom 0
  content: ""



@media (max-width: 950px)
  .processo-info-container-data
    margin 0px

  .processo-info-container-principal-data
    flex-direction column

  .processo-info-anexo-nome
    max-width 50vw

.processo-info-detalhe
    width 200px

@media (max-width: 1140px) and (min-width: 960px)
  .processo-info-detalhe
    width 130px


</style>